export const convert24hTo12h = (time: string) => {
  const [hours, minutes] = time.split(":");
  const hoursInt = parseInt(hours);
  const minutesInt = parseInt(minutes);
  const ampm = hoursInt >= 12 ? "PM" : "AM";
  const hours12 = hoursInt % 12 || 12;
  return `${hours12}:${minutesInt.toString().padStart(2, "0")} ${ampm}`;
};
